import { pruneOversizedCookies } from '@/utils/cookieGuard'

export default () => {
  pruneOversizedCookies()
}
